export function drawGradientChart(canvas, gradientSummary, minRunnable, maxRunnable) {
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const margin = { top: 40, right: 40, bottom: 60, left: 60 };
  const chartWidth = canvas.width - margin.left - margin.right;
  const chartHeight = canvas.height - margin.top - margin.bottom;
  if (!gradientSummary || gradientSummary.length === 0) return;

  const maxSegments = Math.max(...gradientSummary.map(item => item.segmentCount));
  const barWidth = chartWidth / gradientSummary.length;

  gradientSummary.forEach((item, index) => {
    const barHeight = (item.segmentCount / maxSegments) * chartHeight;
    const x = margin.left + index * barWidth;
    const y = margin.top + chartHeight - barHeight;
    const gradientValue = item.gradientMidpoint;
    const isRunnable = gradientValue >= minRunnable && gradientValue <= maxRunnable;
    ctx.fillStyle = item.segmentCount > 0 ? (isRunnable ? '#28a745' : '#007bff') : '#e9ecef';
    ctx.fillRect(x + 2, y, barWidth - 4, barHeight);

    if (barHeight > 20) {
      ctx.fillStyle = 'white';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(item.segmentCount, x + barWidth / 2, y + 15);
    }
  });

  // Axes
  ctx.strokeStyle = '#333';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(margin.left, margin.top);
  ctx.lineTo(margin.left, margin.top + chartHeight);
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(margin.left, margin.top + chartHeight);
  ctx.lineTo(margin.left + chartWidth, margin.top + chartHeight);
  ctx.stroke();

  // Y labels + grid
  ctx.fillStyle = '#333';
  ctx.font = '12px Arial';
  ctx.textAlign = 'right';
  for (let i = 0; i <= 5; i++) {
    const value = Math.round((maxSegments / 5) * i);
    const y = margin.top + chartHeight - (chartHeight / 5) * i;
    ctx.fillText(value, margin.left - 10, y + 4);

    if (i > 0) {
      ctx.strokeStyle = '#e9ecef';
      ctx.beginPath();
      ctx.moveTo(margin.left, y);
      ctx.lineTo(margin.left + chartWidth, y);
      ctx.stroke();
      ctx.strokeStyle = '#333';
    }
  }

  // X labels
  ctx.textAlign = 'center';
  const labelInterval = Math.max(1, Math.floor(gradientSummary.length / 10));
  gradientSummary.forEach((item, index) => {
    if (index % labelInterval === 0 || index === gradientSummary.length - 1) {
      const x = margin.left + index * barWidth + barWidth / 2;
      const y = margin.top + chartHeight + 20;
      const lowerValue = item.gradientRange.split('%')[0];
      ctx.fillText(lowerValue + '%', x, y);
    }
  });

  // Titles
  ctx.font = 'bold 16px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Gradient Distribution', canvas.width / 2, 25);

  ctx.save();
  ctx.translate(20, canvas.height / 2);
  ctx.rotate(-Math.PI / 2);
  ctx.font = '14px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Number of Segments', 0, 0);
  ctx.restore();

  ctx.font = '14px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Gradient Range (%)', canvas.width / 2, canvas.height - 10);
}

